import { render, staticRenderFns } from "./ScalingSquaresSpinner.vue?vue&type=template&id=dbacb9de&scoped=true&"
import script from "./ScalingSquaresSpinner.vue?vue&type=script&lang=js&"
export * from "./ScalingSquaresSpinner.vue?vue&type=script&lang=js&"
import style0 from "./ScalingSquaresSpinner.vue?vue&type=style&index=0&id=dbacb9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbacb9de",
  null
  
)

export default component.exports